import React from 'react';
import './Footer.css'

function Footer() {
    return (
        <footer className="Footer">
            Make with<span role="img" aria-label="heart">❤️</span> for <a target="_blank" rel="noopener noreferrer" href="https://github.com/condef5/">condef5</a>
        </footer>
    )
}

export default Footer;
